<app-popin [popinTitle]="'alerts.smart_alerts.smart_budget.configuration.dialog_title'"
           [disableHighlight]="true">
  <ng-container content>
    <app-smart-alert-configuration-dialog-parts-container [@.disabled]="disableAnimation">
      <app-smart-alert-configuration-dialog-part name="alerts.smart_alerts.configuration_common.sensitivity"
                                                 description="alerts.smart_alerts.configuration_common.sensitivity_desc">
        <app-smart-alert-configuration-dialog-sensitivity [control]="sensitivityCtrl"></app-smart-alert-configuration-dialog-sensitivity>
      </app-smart-alert-configuration-dialog-part>
      <mat-expansion-panel class="mat-elevation-z" togglePosition="before" expanded="false" *ngIf="multisourcesVisible">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="smart-budget-advanced-configuration-title">{{ 'alerts.smart_alerts.configuration_common.advanced_configuration' | translate }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-smart-alert-configuration-dialog-multiple-sources
          [datasources]="dataSources$ | async"
          [form]="form"
          (showAdvancedSettings)="multisourcesVisible = $event"
          [alert]="alert"></app-smart-alert-configuration-dialog-multiple-sources>
      </mat-expansion-panel>
    </app-smart-alert-configuration-dialog-parts-container>
  </ng-container>
  <ng-container actions>
    <app-button type="reset"
                buttonType="mat-button"
                [disabled]="loading$ | async"
                (onClick)="dialogRef.close(null)">{{ 'button.cancel' | translate }}</app-button>
    <app-button type="submit"
                [loader]="loading$ | async"
                [disabled]="!form.valid || (loading$ | async)"
                buttonType="mat-raised-button"
                (onClick)="onSubmit()">{{ 'button.apply' | translate }}</app-button>
  </ng-container>
</app-popin>
